<template>
    <kt-panel>
        <kt-panel-body>
            <form class="kt-form" @submit.prevent="edit" id="marketer_specific_setting">
                <kt-form-label>
                    <h5>
                        {{ $t('marketing.marketing_setting.marketing_percent') }}
                    </h5>
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-section>
                            <kt-form-group>
                                <kt-form-label for="marketing_level_1">
                                    {{ $t('marketing.marketing_setting.level_1') }}
                                </kt-form-label>
                                <kt-form-control
                                        type="number"
                                        placeholder="0-100"
                                        name="marketing_level_1"
                                        id="marketing_level_1"
                                        max="100"
                                        v-model="marketer_specific_setting.profit_percent_level_1"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-form-section>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group >
                            <kt-form-label for="marketing_level_2">
                                {{ $t('marketing.marketing_setting.level_2') }}
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    placeholder="0-100"
                                    name="marketing_level_2"
                                    id="marketing_level_2"
                                    max="100"
                                    v-model="marketer_specific_setting.profit_percent_level_2"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="4" xs="12">
                        <kt-form-group>
                            <kt-form-label for="marketing_level_3">
                                {{ $t('marketing.marketing_setting.level_3') }}
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    placeholder="0-100"
                                    name="marketing_level_3"
                                    id="marketing_level_3"
                                    max="100"
                                    v-model="marketer_specific_setting.profit_percent_level_3"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-label>
                    <h5>
                        {{ $t('marketing.marketing_setting.reports_setting') }}
                    </h5>
                </kt-form-label>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <div class="custom-control custom-checkbox" id="settlements_reports_setting-div">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            id="settlements_reports_setting"
                            name="settlements_reports_setting"
                            v-model="marketer_specific_setting.show_settlements_reports_status"
                            @change="changeLabel($event, 'disable_toggle_settlement')"
                        >
                        <label class="custom-control-label" id="settlements_reports_setting_label" for="settlements_reports_setting">
                            {{ $t('marketing.marketing_setting.showSubsetsSettlementsReportToMarketer') }}
                        </label>
                    </div>
<!--                    <div class="ml-5 custom-control custom-checkbox" id="selectAll-div">-->
<!--                        <input-->
<!--                            type="checkbox"-->
<!--                            class="custom-control-input"-->
<!--                            id="all_subsets_settlements_reports_setting"-->
<!--                            name="all_subsets_settlements_reports_setting"-->
<!--                            @change="selectAll('userSettlementsReports')"-->
<!--                        >-->
<!--                        <label class="custom-control-label" for="all_subsets_settlements_reports_setting">-->
<!--                            {{ $t('marketing.marketing_setting.selectAll') }}-->
<!--                        </label>-->
<!--                    </div>-->
                </kt-row>
                <kt-row lg="12" md="12" xs="12" :class="'ml-1 mt-3 mb-3' + ' ' + getDisableStatus(this.marketer_specific_setting.show_settlements_reports_status)"
                        id="disable_toggle_settlement"
                >
                    <kt-col lg="12" md="12" xs="12">
                        <kt-form-group>
                            <select
                              multiple
                              class="form-control kt-selectpicker"
                              id="userSettlementsReports"
                              name="userSettlementsReports"
                              v-model="marketer_specific_setting['subsets_settlements_report']"
                            >
                                <option
                                  v-bind:key="index"
                                  v-for="(subset, index) in marketer_subsets"
                                  v-bind:value="subset.hashid"
                                  :selected="isSelected(subset.hashid, 'settlements')"
                                >
                                    {{ subset.full_name }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" class="ml-1">
                    <div class="custom-control custom-checkbox" id="reports_setting-div">
                        <input
                                type="checkbox"
                                class="custom-control-input"
                                id="reports_setting"
                                name="reports_setting"
                                v-model="marketer_specific_setting.show_transactions_reports_status"
                                @change="changeLabel($event, 'disable_toggle')"
                        >
                        <label class="custom-control-label" id="reports_setting_label" for="reports_setting">
                            {{ $t('marketing.marketing_setting.showSubsetsTransactionsReportToMarketer') }}
                        </label>
                    </div>
                </kt-row>
                <kt-row lg="12" md="12" xs="12" :class="'ml-1 mt-3 mb-3'  + ' ' + getDisableStatus(this.marketer_specific_setting.show_transactions_reports_status)"
                        id="disable_toggle"
                >
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <label class="mb-3">
                                {{ $t('marketing.marketing_setting.reportFromApp') }}
                            </label>
                            <select
                                    multiple
                                    class="form-control kt-selectpicker"
                                    id="userReportsFromApp"
                                    name="userReportsFromApp"
                                    v-model="marketer_specific_setting['subsets_app_report']"
                            >
                                <option
                                        v-bind:key="index"
                                        v-for="(subset, index) in marketer_subsets"
                                        v-bind:value="subset.hashid"
                                        :selected="isSelected(subset.hashid, 'app')"
                                >
                                    {{ subset.full_name }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <label class="mb-3">
                                {{ $t('marketing.marketing_setting.reportFromPSP') }}
                            </label>
                            <select
                                    multiple
                                    class="form-control kt-selectpicker"
                                    id="userReportsFromPSP"
                                    name="userReportsFromPSP"
                                    v-model="marketer_specific_setting['subsets_psp_report']"
                            >
                                <option
                                        v-bind:key="index"
                                        v-for="(subset, index) in marketer_subsets"
                                        v-bind:value="subset.hashid"
                                        :selected="isSelected(subset.hashid, 'psp')"
                                >
                                    {{ subset.full_name }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-action class="mt-4">
                    <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                        {{ $t('btn.edit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>
    import $ from 'jquery'
    import { KTApp } from '@/plugins/core/app'
    import { KTUtil } from '@/plugins/core/util'
    import {marketingService} from "../../../common/api.service";
    import { i18n } from '@/plugins/i18n'
    import {mapGetters} from "vuex";

    export default {
        props: {
            // marketer_specific_setting: {
            //     required: true
            // },
            marketer_subsets: {
                required: true
            },
            status: {
                required: true
            }
        },
        computed: {
            ...mapGetters('marketing', [
                'marketer_specific_setting'
            ]),
        },
        methods: {
            isSelected(hashid, item) {
                if (item === 'app' && this.marketer_specific_setting['subsets_app_report'])
                    return this.marketer_specific_setting['subsets_app_report'].includes(hashid);
                else if (item === 'psp' && this.marketer_specific_setting['subsets_psp_report'])
                    return this.marketer_specific_setting['subsets_psp_report'].includes(hashid);
            },
            edit(e) {
                let btn = $('#submit_btn')
                let form = $('#marketer_specific_setting')

                KTApp.progress(btn)

                let params = {
                    hashid: this.$route.params.user_id,
                    profit_percent_level_1: this.marketer_specific_setting.profit_percent_level_1,
                    profit_percent_level_2: this.marketer_specific_setting.profit_percent_level_2,
                    profit_percent_level_3: this.marketer_specific_setting.profit_percent_level_3,
                    show_transactions_reports_status: this.marketer_specific_setting.show_transactions_reports_status,
                    show_settlements_reports_status: this.marketer_specific_setting.show_settlements_reports_status,
                    subsets_for_psp_report: this.marketer_specific_setting['subsets_psp_report'],
                    subsets_for_app_report: this.marketer_specific_setting['subsets_app_report'],
                    subsets_for_settlements_report: this.marketer_specific_setting['subsets_settlements_report'],
                }

                marketingService.changeSpecificMarketerPercentSetting(params)
                    .then(response => {
                        this.showMsg(form, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        this.showMsg(form, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            changeLabel(e, disableToggleId) {
                let label = $('#' + e.target.id + '_label')
                let checkbox = $('#' + e.target.id)

                if (checkbox.is(':checked')) {
                    $('#' + disableToggleId).removeClass('is-disabled')
                } else {
                    $('#' + disableToggleId).addClass('is-disabled')

                }
            },
            getDisableStatus(status) {
                if (status === 0)
                    return 'is-disabled';
                else
                    return '';
            },
            afterDispatch() {
                setTimeout(function () {
                    $('.kt-selectpicker').selectpicker({
                        size: 4,
                        liveSearch: true,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_selected')
                    })
                }, 2000)
            },
            selectAll(selectOptionsId) {
                $('#' + selectOptionsId +  'option').prop('selected', true)
            }
        },
        mounted() {
            this.afterDispatch()
        }
    }
</script>

<style>
    .is-disabled {
        pointer-events: none;
        opacity: 0.4;
        /*display: none;*/
    }
</style>